import React from 'react';
import ComboBox from '../../../../components/ComboBox';
import SelectUserComboBox from '../../../../components/SelectUserComboBox';
import dataModel from '../../../../models/DataModel';
import CollectionDataSource from '../../../../dao/DataSource/CollectionDataSource';
import CheckBox from '../../../../components/CheckBox';
import FilterTags from '../../../../components/FilterTags';
import ReportDatePicker from '../../ReportDatePicker';
import DateUtil from '../../../../helpers/DateUtil/DateUtil';
import projectsService from '../../../../services/projectsService';
import caret from '../../../../assets/images/caret.svg';
import anime from 'animejs';

import './ProjectReportFilters.scss';

import BaseComponent from '../../../../baseClasses/BaseComponent';

export default class ProjectReportFilters extends BaseComponent {
  constructor(props){
    super(props);
    
    const { statuses, project_types, project_managers, projectEventType, startDate, endDate, contractIds } = props.selectedFilters;
    this.state = {
      selectedStatuses: statuses || null,
      selectedContractIds: contractIds || null,
      selectedProjectTypes: project_types || null,
      selectedProjectManagers: project_managers || null,
      selectedProjectEvent: projectEventType || 'all',
      startDate,
      endDate,
    };
    
    this.projectEventTypes = [
      { name: '-- All Event Types --', type: 'all', selected: true },
      { name: 'Project Completed', type: 'completed' },
      { name: 'Project Created', type: 'created' },
    ];
    this.statusList = [
      { type: 'all', name: '-- All Status --', all: true },
      { type: 'not_started', name: 'Not Started' },
      { type: 'in_progress', name: 'In Progress' },
      { type: 'complete', name: 'Complete' },
    ];
  }

  handleProjectTypesRetrieval(projectTypes) {
    this.setState({ projectTypes });
  }

  componentDidMount() {
    let contract_ids = [];
    dataModel.usersDAO.getProjectManagers(this.props.markets).then(projectManagers => {
      if (projectManagers && this.projectTypesDataSource) {
        projectManagers.unshift({ id: -1, all: true, first_name: '-- All Project Managers --', last_name: '', multiSelect: true });
        this.setState({ projectManagers: projectManagers });
      }
    });

    this.projectTypesDataSource = new CollectionDataSource('ProjectTypesCollection', 'ProjectType', { project_type: {} },
      this.handleProjectTypesRetrieval, 'ProjectReportFiltersProjectTypes', null, localStorage.current_company_id);
    this.projectTypesDataSource.current();

    projectsService.getAllContractIds()
    .then(response=>{
      if (response.contract_ids) {
        response.contract_ids.forEach(contract_id => {
          contract_ids.push({ type: contract_id, name: contract_id });
        });
        contract_ids.unshift({ type: 'none', name: '-- None --' });
        contract_ids.unshift({ type: -1, name: '-- All Contract Ids --', all: true });
        this.setState({ contractIds: contract_ids });
      }
    });
  }

  componentWillUnmount() {
    if (this.projectTypesDataSource) {
      this.projectTypesDataSource.release();
      this.projectTypesDataSource = null;
    }
  }

  handleClickOutside(event) {
    if (this.reportDatePicker && !this.reportDatePicker.contains(event.target) && !event.target.className.includes('react-datepicker')) {
      this.handleDateDisplay();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedFilters != this.props.selectedFilters && this.props.selectedFilters) {
      this.setState({
        selectedStatuses: this.props.selectedFilters && this.props.selectedFilters.statuses ? this.props.selectedFilters.statuses : null,
        selectedProjectTypes: this.props.selectedFilters && this.props.selectedFilters.project_types ? this.props.selectedFilters.project_types : null,
        selectedProjectManagers: this.props.selectedFilters && this.props.selectedFilters.project_managers ? this.props.selectedFilters.project_managers : null,
      });
    }
  }
  
  handleCloseMenu(){
    if (this.state.menu){
      this.setState({ menu: null, displayMenu: '' });
    }
  }

  handleProjectTypeFilterRemoved(filtersRemoved) {
    const { selectedProjectTypes } = this.state;
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };  
    selectedFilters.project_types = selectedProjectTypes.filter((projectType) => {
      return !filtersRemoved.find((typeRemoved) => {
        return typeRemoved.id == projectType.id;
      });
    });
    handleFilterChange(selectedFilters);
  }

  handleProjectManagerFilterRemoved(filtersRemoved) {
    let { selectedProjectManagers } = this.state;
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.project_managers = selectedProjectManagers.filter((projectManager) => {
      return !filtersRemoved.find((projectManagerRemoved) => {
        return projectManagerRemoved.id == projectManager.id;
      });
    });
    if (selectedFilters.project_managers.length == 0) {
      selectedFilters.project_managers = null;
    }
    handleFilterChange(selectedFilters);
  }

  handleContractIdFilterRemoved(contractIdsRemoved) {
    const { selectedContractIds, contractIds } = this.state;
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    let updatedContractIds = contractIds.map(contractId => {
      if(contractId.type === contractIdsRemoved[0].type){
        contractId.selected = false;
      }
      return contractId;
    });
    let updatedSelectedContactIds = selectedContractIds.filter((contractId) => {
      const removed = contractIdsRemoved.find((contractIdRemoved) => {
        return contractIdRemoved.type == contractId.type;
      });
      return !removed;
    });
    this.setState({ selectedContractIds: updatedSelectedContactIds, contractIds: updatedContractIds });
    selectedFilters.contractIds = updatedSelectedContactIds.map(ms => { return ms.type; });
    handleFilterChange(selectedFilters);
  }

  handleStatusFilterRemoved(statusesRemoved) {
    const { selectedStatuses } = this.state;
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.statuses = selectedStatuses.filter((status) => {
      const removed = statusesRemoved.find((statusRemoved) => {
        return statusRemoved.type == status;
      });
      return !removed;
    });
    handleFilterChange(selectedFilters);
  }

  handleEventFilterRemoved(eventFilters) {
    this.handleProjectEventSelection('all');
  }

  handleDateFilterRemoved(dateFilters) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.projectEventType = this.state.selectedProjectEvent;
    selectedFilters.startDate = this.state.startDate;
    selectedFilters.endDate = this.state.endDate;
    for (const dateFilter of dateFilters) {
      if (dateFilter.type == 'start') {
        selectedFilters.startDate = null;
      } else {
        selectedFilters.endDate = null; 
      }
    }
    this.setState({ startDate: selectedFilters.startDate, endDate: selectedFilters.endDate });
    handleFilterChange(selectedFilters);
  }

  handleProjectTypeChange(multipleSelections) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    this.setState({ selectedProjectTypes: multipleSelections });
    selectedFilters.project_types = multipleSelections.map(ms => { return ms.project_type; });
    handleFilterChange(selectedFilters);
  }

  handleProjectManagerSelection(multipleSelections) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    this.setState({ selectedProjectManagers: multipleSelections });
    selectedFilters.project_managers = multipleSelections.length ? multipleSelections : null;
    handleFilterChange(selectedFilters);
  }

  handleContactIdChange(multipleSelections){
    let { handleFilterChange, selectedFilters } = this.props;
    let { contractIds } = this.state;
    selectedFilters = { ...selectedFilters };
    if(multipleSelections.length===0){
      contractIds.forEach(contractId => {
        contractId.selected = false;
      });
      this.setState({ contractIds: [...contractIds] });
    }
    this.setState({ selectedContractIds: multipleSelections });
    selectedFilters.contractIds = multipleSelections.map(ms => { return ms.type; });
    handleFilterChange(selectedFilters);
  }

  handleStatusChange(multipleSelections) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    this.setState({ selectedStatuses: multipleSelections });
    selectedFilters.statuses = multipleSelections.map(ms => { return ms.type; });
    handleFilterChange(selectedFilters);
  }

  handleShowArchived(checked) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.showArchived = checked;
    handleFilterChange(selectedFilters, checked);
  }

  handleDateSelection(date, type) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.projectEventType = this.state.selectedProjectEvent;
    if (type == 'start') {
      selectedFilters.startDate = date;
      this.setState({ startDate: date });
    } else {
      selectedFilters.endDate = date;
      this.setState({ endDate: date });
    }
    handleFilterChange(selectedFilters);
  }

  handleSetDatePickerRef(element) {
    this.datePicker = element;
  }
  
  handleProjectEventSelection(option) {
    let { handleFilterChange, selectedFilters } = this.props;
    let currentEvent = this.projectEventTypes.find(event => event.selected == true);
    delete currentEvent.selected;
    let newEvent = this.projectEventTypes.find(event => event.type == option);
    newEvent.selected = true;
    this.setState({ selectedProjectEvent: option });
    if (option == 'all') {
      this.setState({ startDate: '', endDate: '' });
      selectedFilters = { ...selectedFilters };
      selectedFilters.startDate = null;
      selectedFilters.endDate = null;
      selectedFilters.projectEventType = null;
      handleFilterChange(selectedFilters);
    }
  }

  async handleDateDisplay() {
    let { filterActive } = this.state;
    await this.setState({ 
      datePickerLeft: this.projectFilterContainer.getBoundingClientRect().left,
      datePickerTop: this.projectFilterContainer.getBoundingClientRect().bottom,
    });
    if (!filterActive) {
      document.addEventListener('click', this.handleClickOutside, false);
      await anime({
        targets: '.ReportDatePicker',
        height: 108,
        easing: 'easeInOutCubic',
        duration: 200,
        begin: () => {
          this.setState({ filterActive: true });
        },
        update: (anim) => {
          if (anim.progress > 50) {
            this.datePicker.style.display = 'flex';
          }
        },
        complete: () => {
          document.querySelector('.ReportDatePicker').style.overflow = 'initial';
        },
      });
    }
    else {
      document.removeEventListener('click', this.handleClickOutside, false);
      await anime({
        targets: '.ReportDatePicker',
        height: 0,
        easing: 'easeInOutCubic',
        duration: 200,
        begin: () => {
          document.querySelector('.ReportDatePicker').style.overflow = 'hidden';
        },
        complete: () => {
          this.setState({ filterActive: false });
        },
        update: (anim) => {
          if (anim.progress > 50) {
            this.datePicker.style.display = 'none';
          }
        },
      });
    }
  }

  createTimeDisplay() {
    let timeDisplay = '';
    if (!this.state.startDate && !this.state.endDate) {
      timeDisplay = '-- All Time --';
      return timeDisplay;
    }
    
    if (this.state.startDate) {
      timeDisplay += DateUtil.formatDateFromDash(this.state.startDate);
    }
    else if (!this.state.startDate) {
      timeDisplay += 'All';
    }
    if (this.state.endDate) {
      timeDisplay = timeDisplay + ' - ' + DateUtil.formatDateFromDash(this.state.endDate);
    }
    else if (!this.state.endDate) {
      timeDisplay += ' - All';
    }
    return timeDisplay;
  }

  render(){
    let { selectedStatuses, selectedProjectTypes, selectedProjectManagers, selectedProjectEvent, selectedContractIds } = this.state;
    const { isVertical, altClassName } = this.props;

    let selectedStatusTags = [];
    let statuses = this.statusList.map(status => {
      let selected = false;
      if (selectedStatuses) {
        let foundType = selectedStatuses.find(sta => {
          return sta.type ? sta.type == status.type : sta == status.type;
        });
        selected = foundType != undefined;
      }
      
      status.selected = selected;
      if (selected) {
        selectedStatusTags.push(status);
      }
      return status;
    });
    
    let statusSelector = null;
    if (!this.props.dontIncludeStatus) {
      statusSelector = <div className={'project-filter-container project-filter-container__project-statuses' + (selectedProjectEvent != 'all' ? ' project-filter-container__project-event-active' : '')}>
        <div className='project-filter-selector-label'>
          {'PROJECT STATUS'}
        </div>
        <div className='project-filter-selector-container'>
          <ComboBox id={'statusPicker'} options={statuses}
            hasBorder={false} underlined={false}
            multiSelect={true}
            height={32}
            width={isVertical ? 304 : 128}
            displayFontStyle={{ fontSize: '12px' }}
            handleMultiMenuSelection={this.handleStatusChange}
            placeHolderText="Project Status" />
        </div>      <div className='project-filter-selector-filtertags'>
          <FilterTags filters={selectedStatusTags} handleFilterRemoved={this.handleStatusFilterRemoved} isDashboard={this.props.isDashboard} />
        </div>
      </div>;
    }

    let selectedEventTags = [];
    if (selectedProjectEvent != 'all') {
      selectedEventTags.push(this.projectEventTypes.find(event => event.type == selectedProjectEvent));
    }

    let dateFilterTags = [];
    if (this.state.startDate) {
      dateFilterTags.push({ type: 'start', name: 'FROM: ' + DateUtil.formatDateFromDash(this.state.startDate) });
    }
    if (this.state.endDate) {
      dateFilterTags.push({ type: 'end', name: 'TO: ' + DateUtil.formatDateFromDash(this.state.endDate) });
    }
    
    let project_typesList = [];
    if (this.state.projectTypes && this.state.projectTypes.length > 0) {
      project_typesList = this.state.projectTypes.map(project_type => {
        let selected = false;
        if (selectedProjectTypes) {
          let foundType = selectedProjectTypes.find(pt => {
            if (pt.project_type) {
              return pt.project_type.id == project_type.id;
            }
            else {
              return pt.id == project_type.id;
            }
          });
          selected = foundType != undefined;
        }
        
        let project_typeOption = { type: project_type.id, name: project_type.name, project_type: project_type, selected: selected };
        return project_typeOption;
      });
    }

    project_typesList.unshift({ type: -1, name: '-- All Types --', all: true });
    let projectManagersList=null;
    if(this.state.projectManagers){
      projectManagersList=this.state.projectManagers.filter(function(user){
        return !user.suspended;
      });  
    }
   
    let project_typeSelector = (
      <ComboBox 
        id={'project_typePicker'}
        options={project_typesList}
        multiSelect={true} 
        hasBorder={false}
        underlined={false}
        backgroundIndex={27}
        height={32}
        width={isVertical ? 304 : 256}
        displayFontStyle={{ fontSize: '12px' }}
        handleMultiMenuSelection={this.handleProjectTypeChange}
        placeHolderText={this.textMap.projectType}
      />
    );

    let projectManagerSelector =
      <SelectUserComboBox 
        key="project_managerPicker"  
        hasBorder={false} 
        multiSelect={true} 
        height={32}  
        width={isVertical ? 304 : 272}
        selectedUsers={selectedProjectManagers ? selectedProjectManagers : []} 
        backgroundIndex={27}
        menuUp={false} 
        menuBelow={true} 
        handleMultipleSelection={this.handleProjectManagerSelection} 
        displayFontStyle={{ fontSize: '12px' }} 
        useMultiTab={false}
        users={projectManagersList}  
      />;

    let contractIdList = null;
    if(this.state.contractIds){
      contractIdList = this.state.contractIds;
    }

    let contractIdSelector = null;
    contractIdSelector = 
      <ComboBox 
        id={'contractIdPicker'} 
        options={contractIdList}
        hasBorder={false} 
        underlined={false}
        multiSelect={true}
        height={32}
        width={isVertical ? 304 : 148}
        displayFontStyle={{ fontSize: '12px' }}
        handleMultiMenuSelection={this.handleContactIdChange}
        placeHolderText="Contract Id" 
      />; 

    let className = altClassName ? altClassName : 'ProjectReportFilters';
    className += isVertical ? ' ' + className + '--vertical' : '';
    className += selectedProjectEvent != 'all' ? ' ' + (altClassName ? altClassName : 'ProjectReportFilters') + '--project-event-active' : '';
    
    return (
      <div className={className}>
        <div className={'project-filter-container project-filter-container__project-types' + (selectedProjectEvent != 'all' ? ' project-filter-container__project-event-active' : '')}>
          <div className='project-filter-selector-label'>
            {this.textMap.projectType.toUpperCase()}
          </div>
          <div className='project-filter-selector-container'>
            {project_typeSelector}
          </div>
          <div className='project-filter-selector-filtertags'>
            <FilterTags filters={selectedProjectTypes} handleFilterRemoved={this.handleProjectTypeFilterRemoved} isDashboard={this.props.isDashboard}/>
          </div>
        </div>
        {statusSelector}
        <div className={'project-filter-container project-filter-container__project-managers' + (selectedProjectEvent != 'all' ? ' project-filter-container__project-event-active' : '')}>
          <div className='project-filter-selector-label'>
            {'PROJECT MANAGERS'}
          </div>
          <div className='project-filter-selector-container'>
            {projectManagerSelector}
          </div>
          <div className='project-filter-selector-filtertags'>
            <FilterTags filters={selectedProjectManagers} handleFilterRemoved={this.handleProjectManagerFilterRemoved} isDashboard={this.props.isDashboard}/>
          </div>
        </div>
        { (!this.props.isDashboard && !this.props.isEventTypeFilterDisabled) &&
          <div className={'project-filter-container' + (selectedProjectEvent != 'all' ? ' project-filter-container__project-event-active' : '')}>
            <div className="project-filter-selector-label">{'EVENT TYPE'}</div>
            <div className='project-filter-selector-container'>
              <ComboBox
                key={'projectEventPicker'}
                id={'projectEventPicker'}
                options={this.projectEventTypes}
                currentOption={this.projectEventTypes.find(event => event.type == selectedProjectEvent)}
                hasBorder={false}
                underlined={false}
                height={31}
                width={192}
                menuHeight={120}
                displayFontStyle={{ fontSize: '12px' }}
                handleSelection={this.handleProjectEventSelection}
              />
            </div>
            <div className='project-filter-selector-filtertags'>
              <FilterTags filters={selectedEventTags} handleFilterRemoved={this.handleEventFilterRemoved} isDashboard={this.props.isDashboard}/>
            </div>
          </div>
        } 
        {
          this.state.selectedProjectEvent != 'all' && 
          <div 
            className={'project-filter-container' + (selectedProjectEvent != 'all' ? ' project-filter-container__project-event-active' : '')} 
            onClick={this.handleDateDisplay}
          >
            <div className="project-filter-selector-label">{'TIME FRAME'}</div>
            <div
              className='project-filter-selector-container project-filter-selector-container__time-frame'
              ref={el => { this.projectFilterContainer = el; }}
            >
              <p className='project-filter-all-time'>
                { this.createTimeDisplay() }
              </p>
              <img className='time-caret' src={caret} role="presentation"/>
            </div>
            <div className='project-filter-selector-filtertags'>
              <FilterTags filters={dateFilterTags} handleFilterRemoved={this.handleDateFilterRemoved} isDashboard={this.props.isDashboard}/>
            </div>
          </div>
        }
        { !this.props.isContractIdFilterDisabled &&
          <div className={'project-filter-container project-filter-container__contract-id' + (selectedProjectEvent != 'all' ? ' project-filter-container__project-event-active' : '')}>
          <div className='project-filter-selector-label'>
            {'CONTRACT ID'}
          </div>
          <div className='project-filter-selector-container'>
            {contractIdSelector}
          </div>
          <div className='project-filter-selector-filtertags'>
            <FilterTags filters={selectedContractIds} handleFilterRemoved={this.handleContractIdFilterRemoved} isDashboard={this.props.isDashboard}/>
          </div>
        </div>}
        <div ref={el => {this.reportDatePicker = el;}} >
          <ReportDatePicker
            handleSetDatePickerRef={this.handleSetDatePickerRef}
            handleDateSelection={this.handleDateSelection}
            selectedProjectEvent={this.state.selectedProjectEvent}
            displayRadioButtons={true}
            left={this.state.datePickerLeft}
            top={this.state.datePickerTop}
            startDate={this.state.startDate}
            endDate={this.state.endDate}
          />
        </div>
        {
          this.props.showArchived != null &&
          <div className={'show-archived-checkbox' + (isVertical ? ' show-archived-checkbox--vertical' : '')}>
            <div className='checkbox'>
              <CheckBox key='check-box' toggleCheckBox={this.handleShowArchived}
                checked={this.props.showArchived} />
            </div>
            <div className='caption'>Include Archived Projects</div>
          </div>
        }
     </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ManagerDashboard/ProjectReport/ProjectReportFilters/index.js